module.exports = __webpack_public_path__ + "img/3.601c7af8.png";